module.exports = __webpack_public_path__ + "static/img/1-4.769563c2.png";